import { Box } from "grommet";
import { EncodingPresets } from "../encoding-presets";
import { Prediction } from "../prediction/prediction";

export function RightSidebar({ sliders, onSlidersChange }: any): React.ReactElement {
  return (
    <Box gridArea="right-sidebar" gap="small">
      <Prediction sliders={sliders} />
      <EncodingPresets onSlidersChange={onSlidersChange} />
    </Box>
  );
}
